<template>
  <div class="register-shell">
    <section class="register-hero">
      <p class="eyebrow">dashcom onboarding</p>
      <h1>创建账号，开始建立你的购物偏好。</h1>
      <p>注册后可以保存地址、收藏商品、追踪订单，也能让推荐更懂你的选择。</p>
    </section>

    <div class="register-card card">
      <h2>用户注册</h2>

      <div v-if="message" :class="['alert', success ? 'alert-success' : 'alert-danger']">
        {{ message }}
      </div>

      <form @submit.prevent="register">
        <div class="form-group">
          <label for="username">用户名</label>
          <input id="username" v-model="form.username" type="text" required placeholder="请输入用户名">
          <span v-if="errors.username" class="error">{{ errors.username }}</span>
        </div>

        <div class="form-group">
          <label for="password">密码</label>
          <input id="password" v-model="form.password" type="password" required placeholder="请输入至少 6 位密码">
          <span v-if="errors.password" class="error">{{ errors.password }}</span>
        </div>

        <div class="form-group">
          <label for="phone">电话</label>
          <input id="phone" v-model="form.phone" type="tel" required placeholder="请输入 11 位手机号">
          <span v-if="errors.phone" class="error">{{ errors.phone }}</span>
        </div>

        <div class="form-group">
          <label for="defaultLocation">默认交易地点</label>
          <input id="defaultLocation" v-model="form.defaultLocation" type="text" required placeholder="请输入默认交易地点">
        </div>

        <button type="submit" class="btn primary-btn" :disabled="isSubmitting">
          {{ isSubmitting ? '注册中...' : '注册' }}
        </button>

        <div class="login-link">
          已有账号？
          <router-link to="/login" class="primary-link">立即登录</router-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomerRegister',
  data() {
    return {
      form: {
        username: '',
        password: '',
        phone: '',
        defaultLocation: ''
      },
      errors: {},
      message: '',
      success: false,
      isSubmitting: false
    }
  },
  created() {
    if (localStorage.getItem('customerToken')) {
      this.$router.push('/')
    }
    if (localStorage.getItem('sellerToken')) {
      this.message = '请先退出卖家账号后再注册用户端'
      this.success = false
      setTimeout(() => {
        this.$router.push('/')
      }, 2000)
    }
  },
  methods: {
    validateForm() {
      this.errors = {}
      let isValid = true

      if (!this.form.phone || !this.form.phone.match(/^1[3-9]\d{9}$/)) {
        this.errors.phone = '请输入有效的 11 位手机号'
        isValid = false
      }

      if (!this.form.password || this.form.password.length < 6) {
        this.errors.password = '密码长度不能少于 6 位'
        isValid = false
      }

      if (!this.form.username || this.form.username.trim().length === 0) {
        this.errors.username = '用户名不能为空'
        isValid = false
      }

      return isValid
    },
    async register() {
      if (!this.validateForm()) {
        return
      }

      this.isSubmitting = true
      this.message = ''

      try {
        const response = await this.$axios.post('/register', null, {
          params: {
            username: this.form.username,
            password: this.form.password,
            phone: this.form.phone,
            defaultLocation: this.form.defaultLocation
          }
        })

        const result = response.data
        if (result.success) {
          this.success = true
          this.message = result.message
          await this.autoLogin()
        } else {
          this.success = false
          this.message = result.message
        }
      } catch (err) {
        this.success = false
        this.message = '注册失败，请稍后重试'
        console.error(err)
      } finally {
        this.isSubmitting = false
      }
    },
    async autoLogin() {
      try {
        const response = await this.$axios.post('/login', null, {
          params: {
            username: this.form.username,
            password: this.form.password
          }
        })

        if (response.data.success && response.data.token) {
          localStorage.setItem('customerToken', response.data.token)
          localStorage.setItem('customerUsername', this.form.username)

          setTimeout(() => {
            this.$router.push('/')
          }, 1000)
        }
      } catch (err) {
        console.error('自动登录失败:', err)
      }
    }
  }
}
</script>

<style scoped>
.register-shell {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(400px, 500px);
  gap: 1.4rem;
  align-items: stretch;
  min-height: calc(100vh - 220px);
}

.register-hero,
.register-card {
  border-radius: 32px;
}

.register-hero {
  padding: 2rem;
  background:
    linear-gradient(135deg, rgba(255, 255, 255, 0.82), rgba(255, 255, 255, 0.3)),
    radial-gradient(circle at 18% 20%, rgba(0, 113, 227, 0.15), transparent 30%),
    linear-gradient(180deg, rgba(250, 250, 252, 0.95), rgba(236, 239, 244, 0.84));
  border: 1px solid rgba(255, 255, 255, 0.7);
  box-shadow: var(--shadow-medium);
}

.eyebrow {
  margin: 0 0 0.8rem;
  color: var(--color-text-faint);
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.register-hero h1 {
  margin: 0;
  max-width: 10ch;
  font-size: clamp(2.3rem, 4vw, 3.8rem);
  line-height: 1;
  letter-spacing: -0.05em;
  color: var(--color-text);
}

.register-hero p:last-child {
  max-width: 480px;
  margin: 1rem 0 0;
  color: var(--color-text-soft);
  line-height: 1.8;
}

.register-card {
  width: 100%;
  margin: 0;
  padding: 2rem;
  background: rgba(255, 255, 255, 0.82);
  border: 1px solid rgba(255, 255, 255, 0.75);
  box-shadow: var(--shadow-soft);
}

.register-card h2 {
  margin: 0 0 1.5rem;
  color: var(--color-text);
  font-size: 1.8rem;
  letter-spacing: -0.03em;
}

.primary-btn {
  width: 100%;
  min-height: 52px;
}

.error {
  display: inline-block;
  margin-top: 0.45rem;
  color: var(--color-danger);
  font-size: 0.84rem;
}

.login-link {
  margin-top: 1rem;
  text-align: center;
  color: var(--color-text-soft);
}

.primary-link {
  color: var(--color-accent-strong);
  text-decoration: none;
  font-weight: 600;
}

.primary-link:hover {
  text-decoration: underline;
}

@media (max-width: 900px) {
  .register-shell {
    grid-template-columns: 1fr;
    min-height: auto;
  }

  .register-hero,
  .register-card {
    border-radius: 24px;
  }
}
</style>
